import Warning from './warning';

/**
 * @class VersionWarning
 * @extends Warning
 */
export default class VersionWarning extends Warning {
    constructor(type, message, icon, items, selection) {
        super(type, message, icon, items);
        this.selection = selection;
    }

    solve() {
        this.selection.clear();
        this.selection.selectItem(this.items[0], true, { showVersion: true });
    }
}
